<template>
    <a-spin tip="Carregando..." :spinning="spinning">
        <div class="container">
            <a-card>
                <template #title>
                    <a-breadcrumb separator=">">
                        <a-breadcrumb-item>
                            <FileOutlined/>
                            <a href="/docs/listar"><span>Documentos</span></a>
                        </a-breadcrumb-item>
                        <a-breadcrumb-item>
                            {{ isEditMode ? 'Editar Documento Template' : 'Cadastrar Documento Template' }}
                        </a-breadcrumb-item>
                    </a-breadcrumb>
                </template>
                <a-tabs>
                    <a-tab-pane key="1" tab="Documento">
                        <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
                            <a-form-item label="Descrição">
                                <a-input v-model:value="data.name"/>
                            </a-form-item>
                            <a-form-item label="Tipo de Certidão">
                                <a-select v-model:value="data.type" placeholder="Selecione" style="width: 350px" :options="optionsDocType"/>
                            </a-form-item>
                            <a-form-item name="upload" label="Documento Template" extra="">
                                <a-upload name="logo" :before-upload="handleBeforeUpload" :onRemove="handleRemove"
                                          :max-count="1" :file-list="data.files">
                                    <a-button>
                                        <template #icon>
                                            <UploadOutlined/>
                                        </template>
                                        Enviar documento template
                                    </a-button>
                                </a-upload>
                            </a-form-item>
                        </a-form>
                    </a-tab-pane>
                    <a-tab-pane key="2" tab="Configuração das Variáveis">
                        <a-row>
                            <a-col :span="4">
                                <strong>Descrição</strong>
                            </a-col>
                            <a-col :span="6">
                                <a-space>
                                    <a-input v-model:value="customConfigs.description" />
                                </a-space>
                            </a-col>

                            <a-col :span="4">
                                <strong>Nome da Variável</strong>
                            </a-col>
                            <a-col :span="6">
                                <a-space>
                                    <a-input v-model:value="customConfigs.variable_name" />
                                </a-space>
                            </a-col>
                        </a-row>
                        <br>
                        <a-row>
                            <a-col :span="4">
                                <strong>Tipo de Variável</strong>
                            </a-col>
                            <a-col :span="6">
                                <a-space>
                                    <a-select v-model:value="customConfigs.type" placeholder="Selecione" style="width: 205px" :options="optionsVarType"/>
                                </a-space>
                            </a-col>

                            <a-col :span="4">
                                <strong>Tipo de Dado</strong>
                            </a-col>
                            <a-col :span="6">
                                <a-space>
                                    <a-select v-model:value="customConfigs.data_type" placeholder="Selecione" style="width: 205px" :options="optionsDataType"/>
                                </a-space>
                            </a-col>
                        </a-row>


                        <a-button @click="addCustomizableConfigs">
                            Adicionar
                        </a-button>

                        <br>
                        <a-table :columns="columns" :data-source="data.custom_configs" bordered>
                            <template #bodyCell="{ column, record }">
                                <template v-if="column.key === 'acao'">
                                    <a-button type="primary" danger shape="circle"
                                              @click="dltCustomizableConfigs(record);">
                                        <template #icon>
                                            <a-tooltip>
                                                <template #title>Excluir</template>
                                                <DeleteOutlined/>
                                            </a-tooltip>
                                        </template>
                                    </a-button>
                                </template>
                            </template>
                        </a-table>
                    </a-tab-pane>
                    <a-tab-pane key="3" tab="Configurações e-cidade">
                        <div class="container">
                            <Codemirror v-model:value="data.code.query" :options="cmOptions" border KeepCursorInEnd
                                        ref="cmRef" height="400" @change="onChange">
                            </Codemirror>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="4" tab="Configurações Geo">
                        <div class="container">
                            <Codemirror v-model:value="data.code_internal.query" :options="cmOptions" border KeepCursorInEnd
                                        ref="cmRef" height="400" @change="onChange">
                            </Codemirror>
                            <a-button v-if="data.code_internal.return_query === ''" style="margin: 10px" @click="viewReturnQuery = true">
                                Adicionar Query Para o Retorno
                            </a-button>
                            <h4 v-else>Query Para o Retorno</h4>
                            <span v-if="viewReturnQuery || data.code_internal.return_query !== ''">
                                <p style="color: red">
                                    Use @ antes do nome do campo que quiser usar o valor. Ex: @matricula
                                </p>
                                <Codemirror v-model:value="data.code_internal.return_query" :options="cmOptions" border KeepCursorInEnd
                                            ref="cmRef" height="400" @change="onChange">
                                </Codemirror>
                            </span>
                        </div>
                    </a-tab-pane>
                </a-tabs>
                <a-button type="primary" @click="handleSave">
                    {{ isEditMode ? 'Salvar Alterações' : 'Salvar' }}
                </a-button>
            </a-card>
        </div>
    </a-spin>
</template>
<script setup>
import {ref, watch, onUnmounted, onMounted} from "vue";
import {DeleteOutlined, FileOutlined, FormOutlined, UploadOutlined} from '@ant-design/icons-vue';
import {notification} from 'ant-design-vue';

import Codemirror from "codemirror-editor-vue3";
import "codemirror/mode/sql/sql.js";
import "codemirror/theme/neat.css";
import axios from "axios";
import { openNotification } from "../../../utils/utilities";

const props = defineProps(["id", "initialData"]);
const labelCol = {span: 4};
const wrapperCol = {span: 14};
const isEditMode = ref(!!props.id);
const spinning = ref(false);
const viewReturnQuery = ref(false)
const columns = ref([
    {
        title: 'Descrição',
        dataIndex: 'description',
        key: 'description',
        sorter: {
            compare: (a, b) => a.id - b.id,
        },
        width: 150,
    },
    {
        title: 'Nome da Variável',
        dataIndex: 'variable_name',
        key: 'variable_name',
        sorter: {
            compare: (a, b) => a.id - b.id,
        },
        width: 150,
    },
    {
        title: 'Tipo da Variável',
        dataIndex: 'type',
        key: 'type',
        sorter: {
            compare: (a, b) => a.id - b.id,
        },
        width: 150,
    },
    {
        title: 'Tipo de Dado',
        dataIndex: 'data_type',
        key: 'data_type',
        sorter: {
            compare: (a, b) => a.id - b.id,
        },
        width: 150,
    },
    {
        title: 'Ação',
        key: 'acao',
        width: 50,
    }
]);

const data = ref({
    name: '',
    type: '',
    code: {
        query: '',
        return_query: ''
    },
    code_internal: {
        query: '',
        return_query: ''
    },
    custom_configs: [],
    files: []
});

const optionsVarType = ref([]);
const optionsDataType = ref([]);
const optionsDocType = ref([]);

const customConfigs = ref({
    description: '',
    variable_name: '',
    data_type: '',
    type: ''
});

const dltCustomizableConfigs = (record) => {
    data.value.custom_configs = data.value.custom_configs.filter(obj => obj.variable_name !== record.variable_name);
}
const addCustomizableConfigs = () => {
    let custom = {...customConfigs.value}
    data.value.custom_configs.push(custom);
    customConfigs.value.description = ''
    customConfigs.value.variable_name = ''
    customConfigs.value.type = ''
    customConfigs.value.data_type = ''
}
const handleRemove = (file) => {
    const index = data.value.files.indexOf(file);
    const newfiles = data.value.files.slice();
    newfiles.splice(index, 1);
    data.value.files = newfiles;
};

const handleBeforeUpload = (file) => {
    data.value.files = [file];
    return false;
};

const handleSave = async () => {
    try {
        spinning.value = true;
        const formData = new FormData();
        formData.append("name", data.value.name);
        formData.append("code", JSON.stringify(data.value.code));
        formData.append("code_internal", JSON.stringify(data.value.code_internal));
        formData.append("doc_type", data.value.type);
        formData.append("custom_configs", JSON.stringify(data.value.custom_configs))
        data.value.files.forEach((file) => {
            formData.append("files", file);
        });

        if (isEditMode.value) {
            formData.append("_method", "PUT");
            await window.axios.post(`/docs/listar/${props.id}`, formData);
        } else {
            await window.axios.post('/docs/listar', formData);
        }
        spinning.value = false;

        openNotification('success', 'Salvo com sucesso');

        if (!isEditMode.value) {
            setTimeout(() => {
                window.location.href = '/docs/listar';
            }, 2000)
        }
    } catch (error) {
        spinning.value = false;
        if (error.response) {
            const {data} = error.response;
            if (data.message && typeof data.message === 'object') {
                const validationErrors = data.message;
                Object.keys(validationErrors).forEach((field) => {
                    openNotification('error', `${field}: ${validationErrors[field].join(', ')}`);
                });
            } else if (data.message) {
                openNotification('error', data.message);
            }
        }
    }
};

const cmRef = ref();
const cmOptions = {
    mode: "text/x-plsql",
    lineNumbers: true,
    theme: "neat"
};

const onChange = (val, cm) => {
    console.log(cm.getValue());
};

onUnmounted(() => {
    cmRef.value?.destroy();
});

onMounted(async () => {
    optionsDataType.value = (await window.axios.get('/api/docs/data-types')).data.data.map(type => {
        return {
            value: type,
            label: type.toString().toUpperCase()
        }
    })

    optionsDocType.value = (await window.axios.get('/api/docs/doc-types')).data.data.map(type => {
        return {
            value: type,
            label: type.toString().toUpperCase()
        }
    })

    optionsVarType.value = (await window.axios.get('/api/docs/variable-types')).data.data.map(type => {
        return {
            value: type,
            label: type
        }
    })


    if (isEditMode.value) {
        try {
            const response = await window.axios.get(`/docs/listar/${props.id}`);
            const doc = response.data.data;
            data.value = {
                name: doc.name,
                type: doc.doc_type,
                code: {
                    query: doc.external_query !== null ? doc.external_query.query : '',
                    return_query: ''
                },
                code_internal: {
                    query: doc.internal_query !== null ? doc.internal_query.query : '',
                    return_query:  doc.internal_query !== null ? doc.internal_query.return_query : ''
                },
                custom_configs: doc.custom_configs
            };
            data.value.files = [{
                url: doc.file_url,
                name: doc.file_name,
                status: 'done'
            }];
        } catch (error) {
            console.error("Erro ao buscar documento.");
        }
    }
});
</script>
